// removed by extract-text-webpack-plugin
module.exports = {"button":"src-components-sitewide-Button-__styles__button--JFrOZ","submit":"src-components-sitewide-Button-__styles__submit--PvF1z","delete":"src-components-sitewide-Button-__styles__delete--3sNQ0","disabled":"src-components-sitewide-Button-__styles__disabled--HLVv3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/sitewide/Button/styles.css
// module id = 2006
// module chunks = 0